var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.servicioSeleccionado)?_c('b-container',[_c('Service-form',{attrs:{"servicioOriginal":_vm.servicioSeleccionado,"puedoEditar":_vm.puedoEditar()},on:{"servicioSubmit":_vm.callUpdateService}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }